import { render } from "./creategroup_page.vue?vue&type=template&id=1bf23db6&scoped=true"
import script from "./creategroup_page.vue?vue&type=script&lang=js"
export * from "./creategroup_page.vue?vue&type=script&lang=js"

import "./creategroup_page.vue?vue&type=style&index=0&id=1bf23db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf23db6"]])

export default __exports__